/**
 * Explorer-only display overrides (on-chain data unchanged).
 * Add entries here when marketing / compliance needs different numbers on screen.
 */

/**
 * Native coin balance forced to 0 in UI (on-chain value unchanged).
 * Includes genesisMint and legacy system contract used on older builds.
 */
const ADDRESS_NATIVE_BALANCE_ZERO_UI = new Set([
  '0x5e63305b60c3aef9194a9d799f737479e6a89467',
  '0x5d19305298341445dd928566451abfab50645286',
]);

/** Same set: hidden from Top Accounts / stats lists where applicable */
export function isAddressNativeBalanceZeroUi(addressHash: string | null | undefined): boolean {
  return Boolean(addressHash && ADDRESS_NATIVE_BALANCE_ZERO_UI.has(addressHash.toLowerCase()));
}

/**
 * Specific tx whose native "Value" / "Amount" column should read 0 in UI.
 * Hash is matched by prefix + suffix so a truncated explorer link still works.
 * (Full hash: extend TX_VALUE_ZERO_PREFIX / SUFFIX or add to TX_VALUE_ZERO_EXACT.)
 */
const TX_NATIVE_VALUE_ZERO_PREFIX = '0x31ab4254';
const TX_NATIVE_VALUE_ZERO_SUFFIX = '807f24744a';

const TX_NATIVE_VALUE_ZERO_EXACT = new Set<string>([
  // Add full 0x…66-char hashes here if prefix+suffix is too loose:
]);

export function getDisplayCoinBalanceWei(
  addressHash: string | null | undefined,
  apiCoinBalance: string | null | undefined,
): string {
  if (addressHash && ADDRESS_NATIVE_BALANCE_ZERO_UI.has(addressHash.toLowerCase())) {
    return '0';
  }
  return apiCoinBalance || '0';
}

export function shouldDisplayTxNativeValueAsZero(txHash: string | null | undefined): boolean {
  if (!txHash) {
    return false;
  }
  const h = txHash.toLowerCase();
  if (TX_NATIVE_VALUE_ZERO_EXACT.has(h)) {
    return true;
  }
  return h.startsWith(TX_NATIVE_VALUE_ZERO_PREFIX) && h.endsWith(TX_NATIVE_VALUE_ZERO_SUFFIX);
}

export function getDisplayTxNativeValueWei(
  txHash: string | null | undefined,
  apiValue: string | null | undefined,
): string {
  if (shouldDisplayTxNativeValueAsZero(txHash)) {
    return '0';
  }
  return apiValue ?? '0';
}
